<template>
  <div>
    <div class="sayfahead">
      <h1>{{ SayfaAdi }}</h1>
      <el-button-group class="float-right">
        <el-button type="danger" size="small" v-if="Yetki" class="YeniBtn" @click="Harcama">
          Harcama İşle
        </el-button>
        <el-button type="success" size="small" v-if="VezneYetki" class="YeniBtn" @click="Odeme">
          Ödeme İşle
        </el-button>
        <el-button type="info" size="small" v-if="Yetki" class="YeniBtn" @click="DuzenleBtn">
          Düzenle
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <el-row :gutter="24">
        <el-col :span="20">
          <CariEkstre :data="Ekstre" v-if="Ekstre" :Yenile="Yenile"></CariEkstre>
        </el-col>
        <el-col :span="4">
          <div class="BlokSabit" style="height: 80vh !important;">
            <div class="BlokSabitKutu">
              <BilgiKutu :data="BilgiKutu"></BilgiKutu>
              <Notlar :data="Notlar"></Notlar>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="Harcama İşle"
      :visible="HarcamaIsleModal"
      center
      width="90%">
      <a @click="ModalKapat" class="ModalKapat"><i class="el-icon-close"></i></a>
      <GiderIsleComp :Cari_id="Cari_id" @Kapat="ModalKapat" @mNo="Makbuz($event)"
                     v-if="HarcamaIsleModal"></GiderIsleComp>
    </el-dialog>

    <FormModal :data="Bilgi" v-if="ModalOlayi" :ModalOlayi="ModalOlayi" :Baslik="Baslik"
               @ModalOlayi="SayfaYukle"></FormModal>

    <OdemeIsle v-if="OdemeIsleModal" :Bina_id="SeciliBina" :Cari_id="Cari_id"
               :OdemeIsleModal="OdemeIsleModal" @OdemeIsleModal="ModalKapat" @mNo="Makbuz($event)"></OdemeIsle>

    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="MakbuzDetayModal=false"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>

  </div>
</template>

<script>

import Notlar from "../../../components/Pack/Genel/Notlar";
import BilgiKutu from "../../../components/Pack/Genel/BilgiKutu";
import FormModal from "../../../components/Pack/Muhasebe/cari/FormModal";
import OdemeIsle from "../../../components/Pack/Muhasebe/cari/OdemeIsle";
import MakbuzDetay from "../../../components/Pack/Vezne/MakbuzDetay";
import CariEkstre from "../../../components/Pack/Muhasebe/cari/CariEkstre";
import GiderIsleComp from "../../../components/Pack/Muhasebe/gider/GiderIsleComp";

export default {
  components: {GiderIsleComp, CariEkstre, MakbuzDetay, OdemeIsle, FormModal, BilgiKutu, Notlar},
  props: ["Cari_id"],
  data() {
    return {
      Yenile: false,
      mNo: null,
      OdemeIsleModal: false,
      HarcamaIsleModal: false,
      MakbuzDetayModal: false,
      ModalOlayi: false,
      SayfaAdi: 'Cari Detay',
      Baslik: 'Cari Detay',
      BilgiKutu: null,
      Yetki: false,
      VezneYetki: false,
      Ekstre: null,
      SeciliBina: null,
      Notlar: {
        Modul: 'Cari',
        Modul_id: this.Cari_id
      },
      Bilgi: {
        Unvan: null,
        Telefon: null,
        Mail: null,
        Adres: null,
        vNo: null,
        vDairesi: null,
        bBilgi: {
          Adi: null,
          Iban: null
        },
      }
    }
  },
  methods: {
    Harcama() {
      if (this.SeciliBina) {
        this.HarcamaIsleModal = true
      } else {
        this.$message.error("Lütfen Bina seçimi yapınız");
      }
    },
    Makbuz(event) {
      this.mNo = event;
      this.MakbuzDetayModal = true;
      this.SayfaYukle()
    },
    DuzenleBtn() {
      this.Baslik = this.Bilgi.Unvan + ' Düzenle';
      this.ModalOlayi = true
    },
    ModalKapat() {
      this.HarcamaIsleModal = false;
      this.Yenile = true;
      this.SayfaYukle();
    },
    SayfaYukle() {

      this.ModalOlayi = false;
      this.OdemeIsleModal = false;
      this.$store.dispatch("Get", {path: 'muhasebe/cari/d/' + this.$route.params.Cari_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Yenile = false;
            this.Bilgi = response.Bilgi;

            this.SayfaAdi = response.Bilgi.Unvan;
            this.Notlar.Modul_id = this.Bilgi.id;
            this.BilgiKutu = {
              Baslik: 'Cari Bilgi',
              Detay: [
                {Baslik: 'Ticari Ünvan', Bilgi: this.Bilgi.Unvan, Ikon: 'flaticon-background'},
                {
                  Baslik: 'Vergi Dairesi / Vergi No. ',
                  Bilgi: this.Bilgi.vDairesi + ' / ' + this.Bilgi.vNo,
                  Ikon: 'flaticon-background'
                },
                {Baslik: 'Telefon', Bilgi: this.Bilgi.Telefon, Ikon: 'flaticon-background'},
                {Baslik: 'Mail', Bilgi: this.Bilgi.Mail, Ikon: 'flaticon-background'},
                {Baslik: 'Adres', Bilgi: this.Bilgi.Adres, Ikon: 'flaticon-background'},
                {Baslik: 'Banka Adı', Bilgi: this.Bilgi.bBilgi.Adi, Ikon: 'flaticon-background'},
                {Baslik: 'IBAN', Bilgi: this.Bilgi.bBilgi.Iban, Ikon: 'flaticon-background'},
              ]
            };

          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

      // CARİ EKSTRE
      this.Ekstre = {
        Bina_id: this.SeciliBina,
        Cari_id: this.$route.params.Cari_id
      };
    },
    Odeme() {
      if (this.SeciliBina) {
        this.OdemeIsleModal = true
      } else {
        this.$message.error("Lütfen Bina seçimi yapınız");
      }
    },
  },
  created() {

    this.Yetki = this.$store.getters.Yetki.muhasebe == '2' ? true : false;
    this.VezneYetki = this.$store.getters.Yetki.vezne == '2' ? true : false;
    if (this.$store.getters.BinaBilgi) {
      this.BinaBilgi = this.$store.getters.BinaBilgi;
      this.SeciliBina = this.BinaBilgi.id;
    }
    this.SayfaYukle();

  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/cari/Detay.vue